import styled from 'styled-components';
import { StyledButton } from './Button.styles';
import { ensurePxUnit } from '../../utils/mobileUtils';

export const SignatureWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const SignaturePad = styled.div`
  width: 100%;
  height: auto;
  aspect-ratio: 2 / 1; /* Sets the ratio (Width / Height) */

  border-width: ${({ styleProps }) => ensurePxUnit(styleProps?.borderSize) || '1px'};
  border-style: ${({ styleProps }) => styleProps?.borderStyle || 'solid'};
  border-color: #000000;
  background-color: ${({ styleProps }) => styleProps?.padBackgroundColor};
  
`;

export const SignatureButtonContainer = styled.div`
  display: flex;
  gap: 4px;
  background: transparent;
  flex-shrink: 0;
  
  order: ${({ isButtonsOnTop }) => (isButtonsOnTop ? -1 : 0)};
  margin-top: ${({ isButtonsOnTop }) => (isButtonsOnTop ? '0px' : '3px')};
  margin-bottom: ${({ isButtonsOnTop }) => (isButtonsOnTop ? '3px' : '0px')};

  & > ${StyledButton} {
    width: 60px;
    flex-shrink: 0;
    border-radius: 2px;
  }
`;